import React from 'react';
import { AlertCircle } from 'lucide-react';

interface WeightSummaryProps {
  totalWeight: number;
  isValid: boolean;
}

export default function WeightSummary({ totalWeight, isValid }: WeightSummaryProps) {
  return (
    <div className="bg-white border rounded-lg">
      <div className="p-4 border-b">
        <h3 className="font-semibold">Total Bobot Kategori</h3>
      </div>
      <div className="p-4 space-y-4">
        <div className="text-center">
          <div className={`text-5xl font-bold ${isValid ? 'text-green-600' : 'text-red-600'}`}>
            {totalWeight}%
          </div>
          <p className="text-sm text-gray-500 mt-1">dari 100%</p>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div
            className={`h-3 rounded-full transition-all duration-300 ${
              isValid ? 'bg-green-500' : totalWeight > 100 ? 'bg-red-500' : 'bg-amber-500'
            }`}
            style={{ width: `${Math.min(totalWeight, 100)}%` }}
          />
        </div>

        {!isValid && (
          <div className="flex items-start gap-2 p-3 bg-red-50 rounded-lg">
            <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-red-700">Total bobot kategori harus tepat 100%</p>
          </div>
        )}
      </div>
    </div>
  );
}
